export default {"src":"/_next/static/media/Cardiomyopathy.5d2968b3.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};